export enum AssessmentTypeEnum {
  Bubble = 'Bubble',
  Handwritten = 'Handwritten',
}
